import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase'; // ✅ adjust path if your firebase config is elsewhere
import PGCard from './PGCard';
import apnagharLogo from './apnaghar.png';
import './PGListing.css';
import './SearchResults.css';

function SearchResults() {
  const navigate = useNavigate();
  const location = useLocation();
  const filteredPGs = location.state?.filteredPGs || [];
  const [pgData, setPgData] = useState(filteredPGs);

  // ✅ Fetch missing city, state, or thumbnailURL from Firestore
  useEffect(() => {
    const fetchExtraDetails = async () => {
      const updated = await Promise.all(
        filteredPGs.map(async (pg) => {
          if (!pg.city || !pg.state || !pg.thumbnailURL) {
            try {
              const docRef = doc(db, 'rent-listings', pg.id); // ✅ replace with your actual collection name
              const snap = await getDoc(docRef);
              if (snap.exists()) {
                const data = snap.data();
                return {
                  ...pg,
                  city: data.city || pg.city,
                  state: data.state || pg.state,
                  thumbnailURL: data.thumbnailURL || pg.thumbnailURL,
                };
              }
            } catch (error) {
              console.error("Error fetching Firestore data:", error);
            }
          }
          return pg;
        })
      );
      setPgData(updated);
    };

    fetchExtraDetails();
  }, [filteredPGs]);

  // ✅ Show only listings that are NOT booked
  const visiblePGs = pgData.filter(pg => !pg.showBooked);

  const handleCardClick = (pg) => {
    navigate(`/pg/${pg.id}`);
  };

  return (
    <div className="search-results-page">
      {/* Header */}
      <button className="back-btn1" onClick={() => navigate(-1)}>← Back</button>
      <div className="search-header">
        <img src={apnagharLogo} alt="Logo" className="search-logo" />
        <h1 className="search-brand-name">ApkaGhr</h1>
      </div>

      {/* Search info */}
      <div className="search-info">
        {visiblePGs.length > 0 ? (
          <h2>
            Showing <span className="highlight">{visiblePGs.length}</span> results for your search
          </h2>
        ) : (
          <h2>Sorry, we couldn't find any PGs or rentals matching your search criteria</h2>
        )}
        <p className="search-subtext">
          Discover premium, verified, and budget-friendly PG or rental accommodations across Assam.
          Click on a listing to view more details and schedule your visit.
        </p>
      </div>

      {/* PG/Rent Cards */}
      {visiblePGs.length > 0 && (
        <div className="search-list">
          {visiblePGs.map(pg => (
            <div key={pg.id} className="pg-card-with-road">
              <PGCard pg={pg} handleClick={handleCardClick} />
            </div>
          ))}
        </div>
      )}

      {/* No results message */}
      {visiblePGs.length === 0 && (
        <div className="no-results-container">
          <p className="no-results-msg">
            😔 No available PGs or rentals match your filter. Try adjusting your filters or search again.
          </p>
          <button className="back-to-list-btn" onClick={() => navigate(-1)}>
            ← Go Back
          </button>
        </div>
      )}
    </div>
  );
}

export default SearchResults;
